import React from "react";
import bg_curve_white_sh from "../svg/bg_curve_white_sh.png";
import samsung from "../svg/sansungsds_logo.jpg";
import Zionds from "../svg/zions_bc_01.jpg";
import cbank from "../svg/CBankT_03.jpg";
import moveup from "../svg/move_up_bg00.svg";
import move_up_01 from "../svg/move_up_01_f.svg";
import move_up_02 from "../svg/move_up_02_f.png";
import move_up_03 from "../svg/move_up_03_f.png";
import move_up_04 from "../svg/move_up_04_f.png";
import divide_sh from "../svg/divide_sh.png";

const FeaturedEmp = () => {
    return (
      <>
        <div className="bgCurve min-sm:h-[180px] min-sm:-mt-[100px] overflow-hidden w-[130%] -mx-[12%]">
              <img
                className="w-full relative drop-shadow-4xl pt-6"
                src={bg_curve_white_sh}
                alt=""
              />
            </div>
            <div
              id="ta_717"
              className="h-[100px] bg-gradient-to-b from-primary-white to-primary-white relative -mt-[50px] overflow-hidden w-[130%] -mx-[12%]"
            ></div>

        <div className="TAwraps  min-sm:w-[95vw] min-xl:px-12 min-xl:w-[80vw] mb-12 ">
              <div>
                <h3 className="font-semibold text-5xl text-center text-primary-blue max-sm:text-2xl mt-12 mb-20 leading-normal min-sm:px-7">
                  Why 100,000+ workers are using Teamanics to get hired
                </h3>
                <div className="animateRatings relative min-lg:h-[70vh]  max-lg:flex max-lg:flex-col-reverse ">
                  <img
                    className="animMobile moveUP0 min-lg:absolute min-lg:w-[60%] max-lg:w-[90%] max-lg:left-[5%] min-lg:left-[20%] bottom-0 "
                    src={moveup}
                    alt=""
                  />
                  <img
                    className="animateRatingR moveUP4 min-lg:absolute min-lg:w-[30%] min-lg:-right-[2%] min-lg:bottom-[25%] "
                    src={move_up_04}
                    alt=""
                    data-aos="fade-left"
                    data-aos-duration="1600"
                    data-aos-delay="300"
                  />
                  <img
                    className="animateRatingL moveUP3 min-lg:absolute min-lg:w-[30%] min-lg:left-[2%] min-lg:bottom-[31%]"
                    src={move_up_03}
                    alt=""
                    data-aos="fade-right"
                    data-aos-duration="1600"
                    data-aos-delay="700"
                  />
                  <img
                    className="animateRatingB moveUP2 min-lg:absolute min-lg:w-[30%] min-lg:right-[20%] min-lg:top-[15px]"
                    src={move_up_02}
                    alt=""
                    data-aos="fade-up"
                    data-aos-duration="1600"
                    data-aos-delay="1000"
                  />
                  <img
                    className="animateRatingB moveUP1 min-lg:absolute min-lg:w-[30%] min-lg:left-[17%] min-lg:-top-[20px]"
                    src={move_up_01}
                    alt=""
                    data-aos="fade-up"
                    data-aos-duration="1600"
                    data-aos-delay="1200"
                  />
                </div>
              </div>
              <div className="bgDivider min-sm:-mt-[75px] min-2xl:-mt-[96px] max-lg:-mt-[60px] mb-12">
                <img
                  className="w-full relative drop-shadow-4xl pt-6"
                  src={divide_sh}
                  alt=""
                />
              </div>
              <div className=" max-sm:p-5 min-sm:mt-24 max-sm:mt-7 mb-40 font-assistant">
                <h3 className="font-semibold text-5xl text-center text-primary-blue max-sm:text-2xl leading-normal">
                  Featured Employers
                </h3>
                <div className="flex flex-row  gap-4 flex-wrap mt-12 mb-7 min-sm:w-full min-sm:mx-auto justify-evenly">
                  <img
                    className="rounded-2xl shadow-xl min-sm:w-[14%] min-sm:max-h-[112px] max-sm:w-[42%] max-sm:max-h-[98px] px-6 py-4 bg-primary-white"
                    src={samsung}
                    alt=""
                  />
                  <img
                    className="rounded-2xl shadow-xl min-sm:w-[14%] min-sm:max-h-[112px] max-sm:w-[42%] max-sm:max-h-[98px] px-5 py-4 bg-primary-white"
                    src={Zionds}
                    alt=""
                  />
                  <img
                    className="rounded-2xl shadow-xl min-sm:w-[14%] min-sm:max-h-[112px] max-sm:w-[42%] max-sm:max-h-[98px] px-4 py-4 bg-primary-white"
                    src={cbank}
                    alt=""
                  />
                  <img
                    className="rounded-2xl shadow-xl min-sm:w-[14%] min-sm:max-h-[112px] max-sm:w-[42%] max-sm:max-h-[98px] px-4 py-4 bg-primary-white"
                    src={require(`../svg/03_lscc_web2.jpg`)}
                    alt=""
                  />

                  <img
                    className="rounded-2xl shadow-xl min-sm:w-[14%] min-sm:max-h-[112px] max-sm:w-[42%] max-sm:max-h-[98px] px-4 py-4 bg-primary-white"
                    src={require(`../svg/phoenicianPain_logo.jpg`)}
                    alt=""
                  />
                  <img
                    className="rounded-2xl shadow-xl min-sm:w-[14%] min-sm:max-h-[112px] max-sm:w-[42%] max-sm:max-h-[98px] px-4 py-4 bg-primary-white"
                    src={require(`../svg/05_hoa_web2.jpg`)}
                    alt=""
                  />
                  <img
                    className="rounded-2xl shadow-xl min-sm:w-[14%] min-sm:max-h-[112px] max-sm:w-[42%] max-sm:max-h-[98px] p-4 bg-[#0b3954]"
                    src={require(`../svg/sga_logo_sq.png`)}
                    alt=""
                  />
                  <img
                    className="rounded-2xl shadow-xl min-sm:w-[14%] min-sm:max-h-[112px] max-sm:w-[42%] max-sm:max-h-[98px] px-4 py-9 bg-primary-white"
                    src={require(`../svg/ubreakifix_logo.png`)}
                    alt=""
                  />
                  <img
                    className="rounded-2xl shadow-xl min-sm:w-[14%] min-sm:max-h-[112px] max-sm:w-[42%] max-sm:max-h-[98px] px-2 py-2 bg-primary-white"
                    src={require(`../svg/08_draegers_web.jpg`)}
                    alt=""
                  />
                  <img
                    className="rounded-2xl shadow-xl min-sm:w-[14%] min-sm:max-h-[112px] max-sm:w-[42%] max-sm:max-h-[98px] p-4 bg-[#2b2965]"
                    src={require(`../svg/09_back_on_track_web3.jpg`)}
                    alt=""
                  />
                  <img
                    className="rounded-2xl shadow-xl min-sm:w-[14%] min-sm:max-h-[112px] max-sm:w-[42%] max-sm:max-h-[98px] px-2 py-4 bg-primary-white"
                    src={require(`../svg/center_for_dermatology02.png`)}
                    alt=""
                  />
                  <img
                    className="rounded-2xl shadow-xl min-sm:w-[14%] min-sm:max-h-[112px] max-sm:w-[42%] max-sm:max-h-[98px] px-2 py-2 bg-primary-white"
                    src={require(`../svg/11_sky2c_web.jpg`)}
                    alt=""
                  />
                </div>
                <p className="text-center ">
                  Teamanics will also match you to other jobs.{" "}
                </p>
              </div>
            </div>
        
      </>
    );
  };
  export default FeaturedEmp;